/**
 * Public pricing surface — keep in sync with `backend/routes/billing.py` get_pricing_plans().
 * Checkout / Stripe IDs stay on the API; this is display-only for landing + docs.
 */

export type PublicPricingPlan = {
  id: 'free' | 'basic' | 'pro' | 'enterprise';
  displayName: string;
  laneLabel: string;
  priceMonthlyUsd: number;
  description: string;
  cta: string;
  accent?: boolean;
  features: string[];
};

export const PUBLIC_PRICING_PLANS: PublicPricingPlan[] = [
  {
    id: 'free',
    displayName: 'Free',
    laneLabel: 'free lane',
    priceMonthlyUsd: 0,
    description: '3 short videos (5s) per 24 hours, 10 videos per rolling 30 days, starter credits',
    cta: 'Register now',
    features: [
      '3 images per day',
      '3 short videos (5s) per 24 hours',
      '10 videos per rolling 30 days',
      '720p exports',
      'Starter credits',
      'Single active queue',
    ],
  },
  {
    id: 'basic',
    displayName: 'Basic',
    laneLabel: 'basic lane',
    priceMonthlyUsd: 9.99,
    description: 'Perfect for casual creators',
    cta: 'Subscribe',
    features: [
      '50 images per month',
      '20 videos per month',
      'Up to 10s videos',
      '1080p resolution',
      'No watermark',
    ],
  },
  {
    id: 'pro',
    displayName: 'Pro',
    laneLabel: 'pro lane',
    priceMonthlyUsd: 29.99,
    description: 'For professional content creators',
    cta: 'Subscribe',
    accent: true,
    features: [
      '200 images per month',
      '100 videos per month',
      'Up to 30s videos',
      '1080p resolution',
      'No watermark',
      'Priority queue',
      'API access',
    ],
  },
  {
    id: 'enterprise',
    displayName: 'Enterprise',
    laneLabel: 'enterprise lane',
    priceMonthlyUsd: 99.99,
    description:
      'High-volume production: expanded monthly caps, 4K exports, and team-ready workflows',
    cta: 'Subscribe',
    features: [
      '500 images per month',
      '200 videos per month',
      'Up to 60s videos',
      '4K resolution',
      'No watermark',
      'Priority queue',
      'API access',
    ],
  },
];

export function formatPlanPriceUsd(amount: number): string {
  if (amount === 0) return '$0.00';
  return `$${amount.toFixed(2)}`;
}
